module.exports = __webpack_public_path__ + "static/media/ljc.2bca98b7.svg";